import { convertToString, parseDate } from 'utils/datetime';
import { updateDateToParse } from './updateDateToParse';

/** gets date value for single date calendar from epoch date string */
export const convertToParsedDate = (date?: string) =>
  convertToString(parseDate(updateDateToParse(date)));
